document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.details-accordion .single-accordion');

  // Set the first accordion to active on page load
  if (accordions.length > 0) {
    const firstAccordion = accordions[0];
    const content = firstAccordion.querySelector('.content');
    const inner = content.querySelector('.inner');
    firstAccordion.classList.add('active');
    content.style.maxHeight = '180px';
    inner.style.maxHeight = '180px';
  }

  document.querySelectorAll('.details-accordion .title').forEach(button => {
    button.addEventListener('click', () => {
      const thisAccordion = button.closest('.single-accordion');
      const content = thisAccordion.querySelector('.content');
      const inner = content.querySelector('.inner');

      // Close all other accordions
      document.querySelectorAll('.single-accordion').forEach(acc => {
        const accContent = acc.querySelector('.content');
        const accInner = accContent.querySelector('.inner');
        if (acc !== thisAccordion) {
          acc.classList.remove('active');
          accContent.style.maxHeight = null;
          accInner.style.maxHeight = null;
        }
      });

      // Toggle current accordion
      const isOpen = thisAccordion.classList.contains('active');

      if (isOpen) {
        thisAccordion.classList.remove('active');
        content.style.maxHeight = null;
        inner.style.maxHeight = null;
      } else {
        thisAccordion.classList.add('active');
        content.style.maxHeight = '180px';
        inner.style.maxHeight = '180px';
      }
    });
  });


});

  